import { useState } from 'react';
import {  Modal, Input } from 'antd';
import { Transforms } from "slate";
import KoIcon from '@kwapio/icons';
import KoButton from 'packages/button';
export function KIOButton({ editor, disabled, isActive }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [prompt, setPrompt] = useState('');
  const [loading, setLoading] = useState(false);

  const handleOpen = () => setIsModalOpen(true);
  const handleClose = () => {
    setIsModalOpen(false);
    setPrompt('');
  };

  function insertTextToEditor(editor, text) {
    const paragraph = {
      type: 'paragraph',
      children: [{ text }]
    };

    Transforms.insertNodes(editor, paragraph);
  }

  const handleSubmit = async() => {
    setLoading(true);
    const responseText = prompt;
    insertTextToEditor(editor, responseText);
    setLoading(false);
    handleClose();
  };

  return (
    <>
      <KoButton
        type="text"
        className='kioBtn'
        disabled={disabled}
        onClick={handleOpen}
        active={isActive}
        icon={<KoIcon width={20} height={20} name="LoaderFilled" />}
        label="Ask KiO"
        onMouseDown={(e) => e.preventDefault()}
      />
      <Modal
        title="Write with KiO Smart Assistant"
        open={isModalOpen}
        onCancel={handleClose}
        onOk={handleSubmit}
        centered
        width={700}
        confirmLoading={loading}
      >
        <div style={{ padding: "2rem", margin: "1rem 0", background: 'var(--layout)' }}>
          <Input.TextArea
            autoSize={{ minRows: 4, maxRows: 10 }}
            value={prompt}
            onChange={(e) => setPrompt(e.target.value)}
            placeholder="Ask Anything"
          />
        </div>
      </Modal>
    </>
  );
}
